import React, { FunctionComponent, useState, useEffect, Fragment } from 'react'; 
import { Container, Row, Col, Card, Modal, Form, Button } from 'react-bootstrap';
import AddonsModal from './AddonModal';

type PlanCardProps = {
  data: any,
  planSelected?: number,
  activated: boolean,
  upgrade: boolean
};


function routeSignUp() {
  const path = '/signup';
  window.location.href=path
}

const handleSApply = async (event) => {
  event.preventDefault();
  event.stopPropagation();
  routeSignUp();
};

const PlanCard:FunctionComponent<PlanCardProps> = props => {

  const activated = props.activated
  const upgrade = props.upgrade
  const [loadplan, setPlan] = useState(0)

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [pricePlan, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [footer, setFooter] = useState('');
  const [estilo, setEstilo] = useState('text-center planCard');
  const [botonEstilo, setBotonEstilo] = useState({});
  const [botonTipo, setBotonTipo] = useState('plans_button text-center');

  const handleModal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPlan(parseInt(event.target.value));
    if (event.target.value>3) window.location.replace('https://www.101obex.com/#comp-jxad0a3m');
    else handleShow();
  };

  const addPrice = () => {
    if (props.data.monthly_price == 0){
      setPrice('Free');
    }else if(props.data.monthly_price == null){
      setPrice('Contact Sales');
    }else{
      setPrice('$'+props.data.monthly_price);
    }
  }

  useEffect(() => {
    if (props.planSelected==props.data.id){
      setPlan(props.planSelected);

      handleShow();
    }
    if (props.data.name=="Developer") {setDescription("The Developer plan is the perfect place to start designing, developing, and testing APIs.");
        setFooter("");
  }
    if (props.data.name=="Startup") {setDescription("The Startup plan helps to transform your idea into a project.");
    setFooter("*per month, when billed monthly. $41.67 per month, when billed yearly. Taxes and fees may apply.");
  }
    if (props.data.name=="Business") {setDescription("The Business plan helps you rapidly scale-up your organization and manage the entire API workflow, all in one place.");
    setFooter("*per month, when billed monthly. $125.00 per month, when billed yearly. Taxes and fees may apply.");
  }
    if (props.data.name=="Enterprise") {setDescription("The Enterprise plan is our enterprise-grade offering for very large businesses or those in highly regulated industries.");
    
  }

  if (activated) {
    if (upgrade) setEstilo("text-center planCardUpdate"); else setEstilo("text-center planCard");
    setBotonEstilo({});        
    setBotonTipo("plans_button text-center")     
} else {
  if (upgrade) setEstilo("text-center planCardUpdate inactive"); else setEstilo("text-center planCard inactive");
  setBotonEstilo({ backgroundColor: '#474747', borderColor: '#474747' })
  setBotonTipo("plans_button_deactivated text-center");
}

    addPrice();
  }, []);

  return(
    
    <Card className={estilo}>
      

      {(loadplan > 0 && activated) && 
      <AddonsModal 
        show={show}
        handleClose={handleClose}
        nameProject={props.data.name}
        planID={loadplan}
        priceMonthly={props.data.monthly_price}
        priceYear={props.data.annual_price}
        upgrade={upgrade}
      />}
      <Card.Body className="px-2 d-flex flex-column">
        <Card.Title > 
          {props.data.name}
        </Card.Title>
        <Card.Text style={{height:'15vh'}}>
          <span style={{fontSize:'0.9em'}}>{description}</span>
        </Card.Text>
        <Card.Text  className={'plan-price my-5 align-items-center d-flex justify-content-center' +
          (props.data.monthly_price == null? ' contact-sales': '')} >
          {pricePlan}
          {(props.data.monthly_price!=null && props.data.monthly_price!=0) && 
          <span>*</span>}
        </Card.Text>
        <Card.Text className="plan-descrip-request mt-auto">
          {footer}
        </Card.Text>
        <div className="text-center">
          {(props.data.monthly_price==null) ?
          <Button  active={!activated} disabled={!activated} style={botonEstilo} value={props.data.id} className={botonTipo} onClick={handleModal}>
            Contact Us
          </Button>
          :  
          (
            (props.data.monthly_price==0) ?
          <Button  active={!activated} disabled={!activated} style={botonEstilo} value={props.data.id} className={botonTipo} onClick={handleModal}>
          Sign Up
        </Button>:
                  <Button  active={!activated} disabled={!activated} style={botonEstilo} value={props.data.id} className={botonTipo} onClick={handleModal}>
                  Buy Now
                </Button>
            
          )
        }
        </div>
      </Card.Body>
    </Card>

      

  );
      
};

{/* <p className="plan-descrip active">Ideal for individual develpoers</p>
  <p className="plan-descrip active">Developes with a full access</p>
  <p className="plan-descrip active">Begin collaborating with your team</p>
  <p className="plan-descrip active">Accelerate development with powerfull tools</p>
  <p className="plan-descrip active">Authenticate users with SSO</p> */}


export default PlanCard;